<script lang="ts" setup>
import Cart from './Cart.vue';
import CartMobile from './CartMobile.vue';

import { useNuxtApp } from '#app';

const props = defineProps<{
  modelValue: boolean;
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { $device: { isMobile } } = useNuxtApp();

const onUpdateModelValue = (value: boolean): void => {
  emits('update:modelValue', value);
};
</script>

<template>
  <UModal
    v-if="isMobile"
    :model-value="props.modelValue"
    prevent-close
    fullscreen
    @update:model-value="onUpdateModelValue"
  >
    <CartMobile @back="onUpdateModelValue(false)" />
  </UModal>

  <Cart
    v-else
    data-test="cart"
  />
</template>
